// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media(max-width:960px){.auth-popup[data-v-37c64051]  .modal__popup{height:100%;justify-content:center;align-items:center;max-height:-webkit-stretch;max-height:-moz-stretch;max-height:-webkit-fill-available;max-height:-moz-available;max-height:stretch;border-radius:0}}", ""]);
// Exports
module.exports = exports;
